import Enum from "../../../enums/Enum";

const DirectBillingItemStatusEnum = new Enum({
    CREATED: {name: "Created"},
    SENT: {name: "Sent"},
    RESPONDED: {name: "Responded"},
    CANCELLED: {name: "Cancelled"},
    APPROVED: {name: "Approved"},
    DENIED: {name: "Denied"},
    FAILED: {name: "Failed"},
});

export default DirectBillingItemStatusEnum;